import { EventEmitter, Injectable } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleTypeService {


  is_display_vehicle_type_register_component = false;
  vehicleTypeUpdate = new EventEmitter<ZONE>();

  downloadVehicleType = new EventEmitter<boolean>();

  private _vehicle_type_data: VEHICLETYPE = null;


  constructor() { }


  set set_vehicle_type_data(vehicle_type) {
    this._vehicle_type_data = vehicle_type;
  }

  get get_vehicle_type_data() {
    return this._vehicle_type_data;
  }

}

export interface VEHICLETYPE {
  id: number;
  name: string;
}
